import { useMemo } from 'react';

import { ProgressIndicatorItem } from 'components/ProgressIndicator';
import { useJobContext } from 'pages/Job/context';

export interface ProgressIndicatorHook {
  items: ProgressIndicatorItem[];
  showBackButton: boolean;
}

export default function useProgressIndicator(): ProgressIndicatorHook {
  const { page, paymentType, changesStatus } = useJobContext();

  const items: ProgressIndicatorItem[] = useMemo(
    () => [
      changesStatus
        ? {
            type: 'multi',
            substeps: [
              {
                type: 'single',
                active: changesStatus === 'REQUESTED',
              },
              {
                type: 'single',
                active: changesStatus === 'REVIEW',
              },
            ],
          }
        : {
            type: 'single',
            active: page === 'QUOTE',
          },
      paymentType === 'FINANCE'
        ? {
            type: 'multi',
            substeps: [
              {
                type: 'single',
                active: true,
              },
              {
                type: 'single',
                active: false,
              },
              {
                type: 'single',
                active: false,
              },
              {
                type: 'single',
                active: false,
              },
            ],
          }
        : {
            type: 'single',
            active: page === 'CHECKOUT',
          },
      {
        type: 'single',
        active: page === 'COMPLETE',
      },
    ],
    [page, paymentType, changesStatus],
  );

  const showBackButton = useMemo(() => page === 'CHECKOUT', [page]);

  return {
    items,
    showBackButton,
  };
}
